import axios from 'axios';
import { isInstallment } from 'utils/gaAnalytics';
import { putReferer, resetRobinRedirectId } from 'actions/loan';
import { setCPLTriggered } from 'actions/authentication';
import queryStringParser from 'utils/queryStringParser';
import { externalScriptPromise, fromCents } from 'utils/helpers';
import getCookiesManager from 'utils/cookiesManager';

const http = axios.create();

/*
* Once affiliate data sent,
* we do not need 'partnerActivity'
* to avoid sending data multiple times
*/
const cleanSessionStorage = () => {
  window.sessionStorage.removeItem('partnerActivity');
};

const affiliateGetRequest = (url, params) => (
  http.get(url, {
    params,
  }).then(() => {
    cleanSessionStorage();
  })
);

const affiliatePixelRequest = (affiliateObj) => {
  const affiliate = affiliateObj;
  Object.keys(affiliate.params).forEach((param) => {
    affiliate.queryParams.push(`${param}=${affiliate.params[param]}`);
  });

  affiliate.node.src = affiliate.url;
  if (affiliate.queryParams && affiliate.queryParams.length > 0) {
    affiliate.node.src += `?${affiliate.queryParams.join('&')}`;
  }

  affiliate.node.width = '1';
  affiliate.node.height = '1';
  affiliate.node.style.display = 'none';
  affiliate.node.async = affiliate.node.nodeName === 'SCRIPT';

  document.body.appendChild(affiliate.node);
};

function trackAffiliateLV(dispatch, storeState) {
  const { loan, authentication } = storeState;
  let partnerActivity = window.sessionStorage.getItem('partnerActivity');
  if (!partnerActivity) {
    return false;
  }
  partnerActivity = JSON.parse(partnerActivity);
  if (loan.rejected !== null) {
    return false;
  }

  if (partnerActivity.partnerId === 'goaff') {
    const customerType = authentication.isOldCustomer ? 'd5f4d26e' : '74522f73';
    const url = 'https://my.goaff.com/api/transaction.php';
    const params = {
      key: '2290dcc7',
      campaign: '71a9906a',
      type: customerType,
      action: 'add_by_affiliate',
      orderid: loan.id,
      affiliate: partnerActivity.transId,
      status: 'A',
    };
    affiliateGetRequest(url, params);
  }

  if (partnerActivity.partnerId === 'target_circle') {
    const customerType = authentication.isOldCustomer ? 'y37uon' : '9u83nk';
    const url = 'https://p.trackmytarget.com';
    const params = {
      campaignID: 'za7mxy',
      productID: customerType,
      conversionType: 'sale',
      transactionID: loan.id,
      transactionAmount: (loan.selectedProduct.firstDrawAmount / 100).toFixed(2),
      currency: 'EUR',
      tmtData: partnerActivity.transId,
    };
    affiliateGetRequest(url, params);
  }

  if (partnerActivity.partnerId === 'lead_gid') {
    const url = 'https://go.leadgid.ru/aff_lsr';
    const params = {
      a: 'lsr',
      offer_id: '1790',
      transaction_id: partnerActivity.transId,
      adv_sub: loan.id,
    };
    affiliateGetRequest(url, params);
  }

  if (partnerActivity.partnerId === 'do_affiliate') {
    const customerType = authentication.isOldCustomer ? 'CPS2' : 'CPS';
    const url = 'https://tracker2.doaffiliate.net/api/credit24-lv';
    const params = {
      type: customerType,
      sale: loan.id,
      v: partnerActivity.transId,
    };
    affiliateGetRequest(url, params);
  }
  return null;
}

function affiliateInitLT() {
  const queryParameters = queryStringParser.parseAndMakeKeysLowerCase(location.search);
  const cookiesManager = getCookiesManager();
  if (!queryParameters || !cookiesManager) {
    return;
  }
  if (queryParameters.utm_source === 'doaffiliate' && queryParameters.v) {
    cookiesManager.saveValue(queryParameters.v, 'doaff_visitor');
  } else if (queryParameters.utm_source === 'goodaff' && queryParameters.utm_content) {
    cookiesManager.saveValue(queryParameters.utm_content, 'goodaff_visitor');
  }
}

function sendTrackAffiliateLT(loanId, isPositiveDecision, isRefinance) {
  const orderId = `CREDLT${loanId}`;
  window.PostAffTracker.setAccountId('f84bfa17');
  if (isRefinance) {
    const trackerAction = window.PostAffTracker.createAction('c24_refinance');
    trackerAction.setOrderID(orderId);
  } else {
    const trackerSale = window.PostAffTracker.createSale();
    trackerSale.setOrderID(orderId);
  }
  window.PostAffTracker.register();

  const url = 'https://my.goaff.com/api/transaction2.php';
  const params = {
    key: 'e8e49b51',
    campaign: '62839097',
    type: '9869536e',
    action: 'update_by_id_type',
    orderid: orderId,
    status: isPositiveDecision ? 'A' : 'D',
  };
  affiliateGetRequest(url, params);
}

function trackDoAffLT(dispatch, storeState, isTypeCPL) {
  const { loan, authentication } = storeState;
  const cameFromDoaff = document.cookie.includes('doaff_visitor');
  const cameFromGoodaff = document.cookie.includes('goodaff_visitor');

  let visitorCookieName = '';
  if (cameFromDoaff) {
    visitorCookieName = 'doaff_visitor';
  } else if (cameFromGoodaff) {
    visitorCookieName = 'goodaff_visitor';
  }
  if (!visitorCookieName || (cameFromGoodaff && !loan.id)) {
    return;
  }

  const parts = (`; ${document.cookie}`).split(`; ${visitorCookieName}=`);
  const lead = authentication.id;
  if (parts.length === 2 && lead) {
    const oldCustomerType = isTypeCPL ? 'CPL2' : 'CPA2';
    const newCustomerType = isTypeCPL ? 'CPL' : 'CPA';
    const customerType = authentication.isOldCustomer ? oldCustomerType : newCustomerType;
    const uniqueId = parts.pop().split(';').shift();

    let affiliateRequest = {
      queryParams: [],
      node: document.createElement('img'),
    };
    if (cameFromDoaff) {
      affiliateRequest = {
        ...affiliateRequest,
        url: 'https://tracker2.doaffiliate.net/api/credit24-lt',
        params: {
          type: customerType,
          lead,
          v: uniqueId,
        },
      };
    } else if (cameFromGoodaff) {
      affiliateRequest = {
        ...affiliateRequest,
        url: 'https://www.goodaff.com/postback',
        params: {
          campaign_id: '8lfzjj4ljz',
          transaction_id: `CREDLT${loan.id}`,
          click_id: uniqueId,
          type: customerType,
          status: 'A',
        },
      };
    }

    affiliatePixelRequest(affiliateRequest);

    if (isTypeCPL) {
      dispatch(setCPLTriggered());
    } else {
      if (cameFromDoaff) {
        dispatch(putReferer('do_affiliate', uniqueId));
      }
      const cookiesManager = getCookiesManager();
      if (cookiesManager) {
        cookiesManager.removeValue(visitorCookieName);
      }
    }
  }
}

function trackLeadGidLT(storeState) {
  const { loan } = storeState;
  const leadGid = {
    url: 'https://leadgid.go2cloud.org/aff_l',
    params: {
      offer_id: '1395',
      adv_sub: loan.id,
    },
    queryParams: [],
    node: document.createElement('img'),
  };
  affiliatePixelRequest(leadGid);
}

function trackAffiliateAuthenticatedLT(dispatch, storeState) {
  const { authentication: { shouldTriggerCPL } } = storeState;
  if (shouldTriggerCPL) {
    trackDoAffLT(dispatch, storeState, true);
  }
}

function trackAffiliateLT(dispatch, storeState) {
  const { loan, authentication } = storeState;

  const isPositiveDecision = loan.rejected === null;
  if (isPositiveDecision) {
    trackDoAffLT(dispatch, storeState);
  }

  trackLeadGidLT(storeState);

  let partnerActivity = window.sessionStorage.getItem('partnerActivity');
  if (authentication.isOldCustomer || !partnerActivity) {
    return null;
  }
  partnerActivity = JSON.parse(partnerActivity);

  if (partnerActivity.partnerId === 'goaff') {
    const { refinance } = loan;

    if (window.PostAffTracker) {
      sendTrackAffiliateLT(loan.id, isPositiveDecision, refinance);
    } else {
      Promise.all([
        externalScriptPromise(
          'https://my.goaff.com/scripts/trackjs.js',
          'pap_x2s6df8d'
        ),
        externalScriptPromise(
          'https://my.goaff.com/scripts/salejs.php',
          'pap_x2s6df8d',
          true
        ),
      ]).then(() => {
        if (window.PostAffTracker) {
          sendTrackAffiliateLT(loan.id, isPositiveDecision, refinance);
        }
      });
    }
  }

  return null;
}

function affiliateInitFI(props) {
  if (EMBEDDED) {
    const { params } = props;
    const { partnerID } = params;
    const lowerCasePartnerID = partnerID ? partnerID.toLowerCase() : null;

    /**
    * Lainaanet initial pixel
    */
    if (lowerCasePartnerID === 'lainaanet') {
      const lainaaInit = {
        url: 'https://www.googleadservices.com/pagead/conversion/698691161',
        params: {
          random: new Date().getMilliseconds(),
          value: 0,
          label: 'EGINCLbB3rEBENnclM0C',
          guid: 'ON',
          script: 0,
          url: encodeURI(location.href),
        },
        queryParams: [],
        node: document.createElement('img'),
      };
      affiliatePixelRequest(lainaaInit);
      return;
    }

    /**
    * Adtraction initial pixel
    */
    if (params.adtractionChannel) {
      const adtractionInit = {
        url: 'https://track.adtraction.com/t/t',
        params: {
          a: 1185244398,
          as: params.adtractionChannel,
          t: 2,
          tk: 1,
        },
        queryParams: [],
        node: document.createElement('img'),
      };
      affiliatePixelRequest(adtractionInit);
    }

    /* Adtraction initial pixel end */

    /**
    * Performission initial pixel
    */
    if (lowerCasePartnerID === 'performission' && params.performissionChannel) {
      affiliatePixelRequest({
        url: `https://c.trackmytarget.com/${params.performissionChannel}`,
        params: {},
        queryParams: [],
        node: document.createElement('img'),
      });
    }
    /* Performission initial pixel end */
  }
}

function trackAffiliateES(dispatch, storeState) {
  if (PARTNER_PORTAL) {
    return null;
  }

  const { loan, authentication } = storeState;
  const { robinRedirectId } = loan;
  const isPositiveDecision = loan.rejected === null;
  let selectedProduct = {};
  let reject = {};

  if (isPositiveDecision) {
    const queryParams = queryStringParser.parseAndMakeKeysLowerCase(location.search);

    if (queryParams.channel && queryParams.channel === 'robin' && queryParams.r_parameter) {
      affiliatePixelRequest({
        url: 'https://robinacademia.com/p.ashx',
        params: {
          o: 13,
          e: 2,
          f: 'pb',
          r: queryParams.r_parameter,
          t: authentication.id,
        },
        queryParams: [],
        node: document.createElement('img'),
      });
    }
  }

  if (!robinRedirectId) {
    return false;
  } if (isPositiveDecision) {
    selectedProduct = {
      amount: (loan.selectedProduct.principal / 100).toFixed(0),
      interest: loan.selectedProduct.apr.toFixed(0),
      period: loan.selectedProduct.maturityPeriods,
      loanType: isInstallment(loan.productType) ? 'INSTALLMENT' : 'CREDIT_LINE',
    };
  } else {
    reject = {
      rejectionCode: loan.rejected,
      rejectionMessage: loan.rejectedMessage,
    };
  }
  const payload = {
    customerId: authentication.id,
    robinRedirectId,
    isPositiveDecision,
    ...selectedProduct,
    ...reject,
  };
  /*
  * This affiliate is triggered for 2 cases:
  * successful contract submit and rejection message
  */
  http.post(
    'https://robin-pixel.herokuapp.com/api/pixels/',
    payload,
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-type': 'application/json',
      },
    }
  ).then(() => {
    dispatch(resetRobinRedirectId());
  });
  return null;
}

const getTrackMyTargetPixelConfig = ({ id, selectedProduct }, eventSid, transId) => {
  const trackMyTargetPixelConfig = {
    url: 'https://p.trackmytarget.com',
    params: {
      type: 'sale',
      event_sid: eventSid,
      amount: (selectedProduct.firstDrawAmount / 100).toFixed(2),
      currency: 'EUR',
      id,
    },
    queryParams: [],
    node: document.createElement('img'),
  };
  if (transId) {
    trackMyTargetPixelConfig.params.tmt_data = transId;
  }
  return trackMyTargetPixelConfig;
};

const getAdservicePixelConfig = ({ id }, coid) => {
  const adservicePixelConfig = {
    url: 'https://online.adservicemedia.dk/cgi-bin/API/ConversionService/Callback',
    params: {
      camp_id: '4914',
      order_id: id,
      pricevariable: 'New',
    },
    queryParams: [],
    node: document.createElement('img'),
  };
  if (coid) {
    adservicePixelConfig.params.coid = coid;
  }
  return adservicePixelConfig;
};

const trackAffiliateFIEmbedded = (dispatch, { loan, integration }) => {
  const integrationQueryString = queryStringParser.parse(integration.queryString);
  const { transid, coid } = integrationQueryString;
  const partnerSiteQueryParamsValues = Object.values(integrationQueryString);
  const lowercasePartnerID = integration.partnerID ? integration.partnerID.toLowerCase() : null;

  if (lowercasePartnerID === 'lainaanet') {
    const lainaaPixelConfig = {
      url: 'https://www.lainaa.net/conversiondone.php',
      params: {},
      queryParams: [],
      node: document.createElement('img'),
    };
    affiliatePixelRequest(lainaaPixelConfig);
    return true;
  }

  if (lowercasePartnerID === 'rahapalvelu') {
    const rahapalveluPixelConfig = getTrackMyTargetPixelConfig(loan, 'r91a45', transid);
    affiliatePixelRequest(rahapalveluPixelConfig);
    return true;
  }

  if (lowercasePartnerID === 'creditea') {
    const cameFromPerformission = partnerSiteQueryParamsValues
      .map((queryParamValue) => queryParamValue.toLowerCase())
      .some((queryParamValue) => queryParamValue === 'pm' || queryParamValue === 'performission');

    if (cameFromPerformission) {
      const performissionPixelConfig = getTrackMyTargetPixelConfig(loan, 'x3a1l7', transid);
      affiliatePixelRequest(performissionPixelConfig);
      return true;
    }

    const cameFromAdservice = partnerSiteQueryParamsValues
      .map((queryParamValue) => queryParamValue.toLowerCase())
      .some((queryParamValue) => queryParamValue === 'adservice');

    if (cameFromAdservice) {
      const adservicePixelConfig = getAdservicePixelConfig(loan, coid);
      affiliatePixelRequest(adservicePixelConfig);
      return true;
    }
  }

  return false;
};

const trackAffiliateFILoanApp = (dispatch, { loan }) => {
  let partnerActivitySource = window.sessionStorage.getItem('partnerActivitySource');
  if (!partnerActivitySource) {
    return false;
  }
  partnerActivitySource = JSON.parse(partnerActivitySource);
  let cameFromPerformission = false;
  let cameFromAdservice = false;
  const keys = Object.keys(partnerActivitySource);

  for (let i = 0; i < keys.length; i += 1) {
    const value = partnerActivitySource[keys[i]].toLowerCase();
    if (value === 'pm' || value === 'performission') {
      cameFromPerformission = true;
      break;
    }
    if (value === 'adservice') {
      cameFromAdservice = true;
      break;
    }
  }

  if (cameFromPerformission) {
    const performissionPixelConfig = getTrackMyTargetPixelConfig(loan, 'ze9w6b', partnerActivitySource.transid);
    affiliatePixelRequest(performissionPixelConfig);
    return true;
  }
  if (cameFromAdservice) {
    const adservicePixelConfig = getAdservicePixelConfig(loan, partnerActivitySource.coid);
    affiliatePixelRequest(adservicePixelConfig);
    return true;
  }

  return false;
};

const trackAffiliateFI = (dispatch, storeState) => {
  if (EMBEDDED) {
    return trackAffiliateFIEmbedded(dispatch, storeState);
  }
  return trackAffiliateFILoanApp(dispatch, storeState);
};

const trackRejectionAffiliateFI = (dispatch, { loan, integration }) => {
  if (EMBEDDED) {
    const integrationQueryString = queryStringParser.parse(integration.queryString);
    const partnerSiteQueryParamsValues = Object.values(integrationQueryString);
    const lowercasePartnerID = integration.partnerID ? integration.partnerID.toLowerCase() : null;

    if (lowercasePartnerID === 'creditea') {
      const cameFromPerformission = partnerSiteQueryParamsValues
        .map((queryParamValue) => queryParamValue.toLowerCase())
        .some((queryParamValue) => queryParamValue === 'pm' || queryParamValue === 'performission');

      if (cameFromPerformission) {
        const performissionPixelConfig = getTrackMyTargetPixelConfig(loan, 'x6178e', integrationQueryString.transid);
        affiliatePixelRequest(performissionPixelConfig);
        return true;
      }
    }
  }
  return false;
};

function trackAffiliateDrawFI(storeState, drawAmount) {
  const { authentication, selfservice } = storeState;
  let partnerActivitySource = window.sessionStorage.getItem('partnerActivitySource');
  if (partnerActivitySource) {
    partnerActivitySource = JSON.parse(partnerActivitySource);
    const partnerSiteQueryParamsValues = Object.values(partnerActivitySource);
    const contractId = authentication.contracts && authentication.contracts[0];
    const { creditApplication } = selfservice.contracts[contractId];
    const isPerformissionAffiliate = partnerSiteQueryParamsValues.some((queryParamValue) =>
      queryParamValue.toLowerCase() === 'pm' || queryParamValue.toLowerCase() === 'performission');
    const isAdserviceAffiliate = partnerSiteQueryParamsValues.some((queryParamValue) =>
      queryParamValue.toLowerCase() === 'adservice');

    if (isPerformissionAffiliate) {
      const performission = {
        url: 'https://p.trackmytarget.com',
        params: {
          campaignID: 'ukly31',
          productID: 'q88e37',
          conversionType: 'sale',
          transactionID: creditApplication.id,
          transactionAmount: fromCents(drawAmount),
          currency: 'EUR',
        },
        queryParams: [],
        node: document.createElement('img'),
      };
      if (partnerActivitySource.transid) {
        performission.params.tmtData = partnerActivitySource.transid;
      }
      affiliatePixelRequest(performission);
    } else if (isAdserviceAffiliate) {
      const adservice = {
        url: 'https://online.adservicemedia.dk/cgi-bin/API/ConversionService/Callback',
        params: {
          camp_id: '4914',
          order_id: creditApplication.id,
          pricevariable: 'old',
        },
        queryParams: [],
        node: document.createElement('img'),
      };
      if (partnerActivitySource.coid) {
        adservice.params.coid = partnerActivitySource.coid;
      }
      affiliatePixelRequest(adservice);
    }
  }
}

export const affiliateRequestContractSubmitted = (dispatch, getState) => {
  switch (COUNTRY) {
    case 'LV':
      return trackAffiliateLV(dispatch, getState());
    case 'LT':
      return trackAffiliateLT(dispatch, getState());
    case 'FI':
      return trackAffiliateFI(dispatch, getState());
    case 'ES':
      return trackAffiliateES(dispatch, getState());
    default:
      return null;
  }
};

export const affiliateRequestCustomerRejected = (dispatch, getState) => {
  switch (COUNTRY) {
    case 'ES':
      return trackAffiliateES(dispatch, getState());
    case 'LT':
      return trackAffiliateLT(dispatch, getState());
    case 'FI':
      return trackRejectionAffiliateFI(dispatch, getState());
    default:
      return null;
  }
};

export const affiliateRequestAuthenticated = (dispatch, getState) => {
  switch (COUNTRY) {
    case 'LT':
      return trackAffiliateAuthenticatedLT(dispatch, getState());
    default:
      return null;
  }
};

export const affiliateInitRequest = (props) => {
  switch (COUNTRY) {
    case 'FI':
      return affiliateInitFI(props);
    case 'LT':
      return affiliateInitLT();
    default:
      return null;
  }
};

export const affiliateRequestDraw = (getState, drawAmount) => {
  switch (COUNTRY) {
    case 'FI':
      return trackAffiliateDrawFI(getState(), drawAmount);
    default:
      return null;
  }
};
